import { z } from "zod";
import { channelCode, isoDate } from "./common.js";

export const materialCategorySchema = z.object({
  id: z.string(),
  parentId: z.string().nullable(),
  code: z.string(),
  name: z.string(),
  sortOrder: z.number().int(),
  isActive: z.boolean(),
  /** Organization-written required review items for this category. */
  reviewCriteria: z.string().nullable(),
  reviewCount: z.number().int().nonnegative(),
  ruleCount: z.number().int().nonnegative(),
  createdAt: isoDate,
});
export type MaterialCategory = z.infer<typeof materialCategorySchema>;

export const createMaterialCategorySchema = z.object({
  parentId: z.string().min(1).nullable().optional(),
  code: channelCode,
  name: z.string().trim().min(1).max(120),
  sortOrder: z.number().int().min(0).max(9999).optional(),
  reviewCriteria: z.string().trim().max(4000).nullable().optional(),
});
export type CreateMaterialCategoryInput = z.infer<typeof createMaterialCategorySchema>;

export const updateMaterialCategorySchema = z.object({
  name: z.string().trim().min(1).max(120).optional(),
  parentId: z.string().min(1).nullable().optional(),
  sortOrder: z.number().int().min(0).max(9999).optional(),
  isActive: z.boolean().optional(),
  /** Empty text clears the criteria. */
  reviewCriteria: z.string().trim().max(4000).nullable().optional(),
});
export type UpdateMaterialCategoryInput = z.infer<typeof updateMaterialCategorySchema>;
